import { atom } from '@cloudio-saas/statex';

export const allAliasAtom = atom<Record<string, Record<string, string>>>({
  path: ['transient', 'dataSourceAlias', ':appUid'],
  defaultValue: {},
});

export const aliasAtom = atom<Record<string, string>>({
  path: [...allAliasAtom.path, ':pageId'],
  defaultValue: {},
});
